import { render } from "./StarterPage.vue?vue&type=template&id=4a107b12&ts=true"
import script from "./StarterPage.vue?vue&type=script&lang=ts"
export * from "./StarterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__